import React, { useEffect } from "react";

const PasswordControl = ({
  minLength = 0,
  maxLength = 0,
  minLowercase = 0,
  minUppercase = 0,
  minSpecial = 0,
  minNumber = 0,
  password,
  setCanSave,
  style,
}) => {
  useEffect(() => {
    setCanSave(
      minLengthOk() && minLowercaseOk() && minUppercaseOk() && minNumberOk()
    );
  }, [password]);

  function minLengthOk() {
    return password.length >= minLength;
  }
  function minLowercaseOk() {
    return password.replace(/[^a-z]/g, "").length >= minLowercase;
  }
  function minUppercaseOk() {
    return password.replace(/[^A-Z]/g, "").length >= minUppercase;
  }
  function minNumberOk() {
    return password.replace(/[^0-9]/g, "").length >= minUppercase;
  }
  function minSpecialOk() {
    var specialChars = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/gi;
    return (password.match(specialChars) || []).length >= minSpecial;
  }

  const rules = [
    minLength > 0 && {
      label: "Au moins " + minLength + " caractères",
      ok: minLengthOk(),
    },
    minUppercase > 0 && {
      label: minUppercase + " majuscule",
      ok: minUppercaseOk(),
    },
    minLowercase > 0 && {
      label: minLowercase + " minuscule",
      ok: minLowercaseOk(),
    },
    minSpecial > 0 && {
      label: minSpecial + " caractère spécial",
      ok: minSpecialOk(),
    },
    minNumber > 0 && {
      label: minNumber + " chiffre",
      ok: minNumberOk(),
    },
  ].filter(Boolean);

  const strength = rules.filter((r) => r.ok).length;
  const totalRules = rules.length;
  const strengthColors = ["#E5E7EB", "#EF4444", "#F97316", "#F59E0B", "#22C55E", "#16A34A"];
  const strengthLabels = ["", "Très faible", "Faible", "Moyen", "Bon", "Fort"];

  return (
    <div style={{ ...style }}>
      {totalRules > 0 && (
        <div className="d-flex align-items-center" style={{ gap: 12, padding: "8px 0" }}>
          <div className="d-flex flex-grow-1" style={{ gap: 6 }}>
            {Array.from({ length: totalRules }).map((_, i) => (
              <div
                key={i}
                style={{
                  flex: 1,
                  height: 6,
                  borderRadius: 3,
                  background: i < strength ? strengthColors[strength] : "#E5E7EB",
                  transition: "background 200ms",
                }}
              />
            ))}
          </div>
          <div
            style={{
              minWidth: 64,
              textAlign: "center",
              padding: "4px 12px",
              borderRadius: 8,
              background: strength >= totalRules - 1 && strength > 0 ? "#E7F8EE" : "#F1F5F9",
              color: strength >= totalRules - 1 && strength > 0 ? "#16A34A" : "#64748B",
              fontSize: 13,
              fontWeight: 600,
            }}
          >
            {strengthLabels[strength] || "—"}
          </div>
        </div>
      )}
      <div className="row" style={{ margin: 0, padding: "8px 0" }}>
        {rules.map((rule, k) => (
        <div
          key={k}
          className="col-12 col-sm-6 d-flex align-items-center py-1"
          style={{ fontSize: 14 }}
        >
          <span
            style={{
              width: 20,
              height: 20,
              borderRadius: "50%",
              background: rule.ok ? "#22C55E" : "#CBD5E1",
              color: "#FFFFFF",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: 10,
              flexShrink: 0,
            }}
          >
            <i className="fa fa-check" style={{ fontSize: 10, lineHeight: 1 }} />
          </span>
          <span style={{ color: rule.ok ? "#0F172A" : "#64748B" }}>
            {rule.label}
          </span>
        </div>
      ))}
      </div>
    </div>
  );
};

export default PasswordControl;
